import React, { useEffect, useState } from "react";
import "./style.scss";
import LayoutProvider from "../../../../providers/LayoutProvider";
import cardImage from "../../../../assets/images/training/instructor-card-image.png";
import { FaCircleInfo } from "react-icons/fa6";
import { FiPlus, FiX } from "react-icons/fi";
import InstructorCard from "../../../../components/Training/Instructor/InstructorCard";
import AddInstructorModal from "./AddInstructorModal";
import InstructorStudentCard from "../../../../components/Training/common/InstructorStudentCard";

import bgImage from "../../../../assets/images/training/instructor-card-image.png";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Toaster } from "react-hot-toast";
import { API_STATUS } from "../../../../constants";
import InvitationService from "../../../../services/invitation.service";
import useCustomToast from "../../../../hooks/useCustomToast";
import { validateEmail } from "../../../../helpers";
import { getInstructors, getInstructorsFromApi, getStudentInstructorsTotalCount, getUserApiStatus, setInstructorsList, setStatusForStudentInstructor } from "../../../../store/slices/instructor-student.slice";
import SpinnerLoader from "../../../../components/SpinnerLoader";
import { Link } from "react-router-dom";
import StudentPagesProvider from "../../../../providers/StudentPagesProvider";
import InfiniteScroll from "react-infinite-scroll-component";

type Anchor = "right";

function Instructor() {
  const [state, setState] = React.useState({
    right: false,
  });
  const dispatch = useDispatch()
  const instructors = useSelector(getInstructors)
  const totalPages = useSelector(getStudentInstructorsTotalCount)
  const loading = useSelector(getUserApiStatus)
  const [perPage, setPerPage] = useState(30)
  const [page, setPage] = useState(1)
  const [query, setQuery] = useState('')


  const initialInputs = {
    toName: "",
    toEmail: "",
    canViewLogBook: false,
    canAddFlights: false,
    expiration: "",
  }
  const [inputs, setInputs] = React.useState(initialInputs)
  const customToast = useCustomToast()

  React.useEffect(() => {
    dispatch(setInstructorsList([]))
  }, [])
  React.useEffect(() => {
    dispatch(getInstructorsFromApi({ page, per_page: perPage, query }))
  }, [dispatch, perPage, page])


  const toggleDrawer = (anchor: Anchor, open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (event.type === "keydown" &&
      ((event as React.KeyboardEvent).key === "Tab" ||
        (event as React.KeyboardEvent).key === "Shift")) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };


  const handleInput = (e: any) => {
    setInputs((prev) => ({ ...prev, [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value }))
  }

  const sendInvitationToUser = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!inputs?.toEmail) return customToast("Please enter email", "error")
    if (!validateEmail(inputs.toEmail)) return customToast("Please enter a valid email", "error")
    dispatch(setStatusForStudentInstructor(API_STATUS.LOADING))
    const res: any = await InvitationService.sendInvitation(inputs)
    dispatch(setStatusForStudentInstructor(API_STATUS.SUCCEEDED))
    if (res?.status === 201) {
      setInputs(initialInputs)
      customToast(res?.message, "success")
      toggleDrawer("right", false)
      dispatch(getInstructorsFromApi())
    }
  }

  return (
    <StudentPagesProvider>
      <LayoutProvider classNames="instructor__page">
        {loading === API_STATUS.LOADING && <SpinnerLoader />}
        <Toaster />
        <AddInstructorModal inputs={inputs} sendInvitationToUser={sendInvitationToUser} handleInput={handleInput} toggleDrawer={toggleDrawer} state={state} />
        <h2 className="heading2">Your Instructors</h2>

        <InstructorStudentCard
          handleInput={handleInput}
          inputs={inputs}
          sendInvitation={sendInvitationToUser}
          data={{
            bgImage,
            formLabel: "Invite Your Instructor",
            text: `If you would like to track endorsements from your instructor, enter
        their email address below. <br />
        They will confirm that they know you.`,
            buttonText: "Add Instructor",
          }}
        />

        <div className="filters_row d-flex justify-content-between align-items-center flex-wrap gap-3 mt-4">
          <div className="d-flex align-items-center gap-3">
            <h2 className="heading3">Instructors</h2>
            <Link to="/training/invitations">New Invitations</Link>
          </div>
          <div className="d-flex align-items-center flex-wrap gap-3">
            <button className="button" onClick={toggleDrawer("right", true)}>
              <span>
                <FiPlus />
                <span>Add Instructor</span>
              </span>
            </button>
          </div>
        </div>

        {!instructors?.length ? <div className="alert alert-warning my-4 d-flex align-items-center justify-content-between  py-2">
          <div className="d-flex align-items-center gap-2 p-0 m-0">
            <FaCircleInfo />
            <div className="fw-semibold">You have no Instructor to display</div>
          </div>
          <div className="close_icon" role="button">
            <FiX />
          </div>
        </div> : null}

        <InfiniteScroll
          dataLength={instructors?.length}
          loader={loading === API_STATUS.LOADING}
          next={() => {
            setPage((prev) => prev + 1)
          }}
          hasMore={page < totalPages}
          style={{ overflowX: "hidden" }}
        >
          <div className="instructors mt-3">
            <div className="row">
              {instructors?.map((instructor: any, i: number) => (
                <InstructorCard cardImage={cardImage} data={instructor} key={i} />
              ))}
            </div>
          </div>
        </InfiniteScroll>
      </LayoutProvider>
    </StudentPagesProvider>
  );
}

export default Instructor;
